import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'instructionState';

export const getAllInstructionVideos = createAsyncThunk(
    'instructionState/getAllInstructionVideos',
    async (_, { getState, rejectWithValue }) => {
        try {
            const group = getState().deviceState.activeDevice.group;
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/audiovideos?group=${group}&tag=Instruction`,
                withCredentials: true,
                auth: createAuth(getState)
            });
            return response.data;
        } catch (error) {
            console.log('ERROR FETCHING INSTRUCTIONVIDEOS', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    instructionVideos: [],
    currentVideo: null,
    status: 'idle',
    error: null,
};

const instructionSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        play: (state, action) => {
            state.currentVideo = action.payload;
        },
        stopPlay: (state) => {
            state.currentVideo = null;
        },
    },
    extraReducers: (builder) => {
        builder
            //getAllInstructionVideos
            .addCase(getAllInstructionVideos.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getAllInstructionVideos.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.instructionVideos = action.payload;
                // Reset currentVideo if out of bounds
                if (state.currentVideo !== null && action.payload.length <= state.currentVideo) {
                    state.currentVideo = null;
                }
            })
            .addCase(getAllInstructionVideos.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export const { play, stopPlay } = instructionSlice.actions;

export default instructionSlice.reducer;